(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
"use strict";

var _jquery = _interopRequireDefault((typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Show a tooltip when hovering over a glossary term link.
 * 
 * @since 1.0.0
 */
var glossary = _objectSpread({}, window.emGlossary, {
  /**
   * Boolean to check if an xhr request is currently in progress.
   */
  requestInProgress: false,

  /**
   * Tooltip class and prefix for tooltip component classes.
   * 
   * @since 1.0.1
   * 
   * @type {String}
   */
  tooltipClass: 'emg-tooltip',

  /**
   * Class added to glossary term link to display the tooltip.
   * 
   * @since 1.0.1
   * 
   * @type {String}
   */
  showTooltipClass: 'show-tooltip',

  /**
   * Class added to glossary term link after the tooltip HTML has been added to the link.
   * This prevents WP REST API requests being made for the same link more than once.
   * 
   * @since 1.0.1
   * 
   * @type {String}
   */
  hasTooltipClass: 'has-tooltip',

  /**
   * Class added to glossary term link after the tooltip content has been loaded.
   * 
   * @since 1.0.1
   * 
   * @type {String}
   */
  tooltipLoadedClass: 'tooltip-loaded',

  /**
   * Class added to glossary term link while the tooltip content is loading.
   * 
   * @since 1.0.1
   * 
   * @type {String}
   */
  tooltipLoadingClass: 'tooltip-loading',

  /**
   * Class added to glossary term link when the tooltip is going to appear above
   * the window.emGlossaryOptions.topOffsetEl.
   * 
   * @since 1.0.3
   * 
   * @type {String}
   */
  tooltipBottomClass: 'tooltip-bottom',

  /**
   * Get all glossary term links on the page and add events.
   * 
   * @since 1.0.0
   * @since 1.0.1 Added focus, blur, and touchend event listeners for better accessibility and mobile support.
   * @since 1.0.3 Added touchstart event to close the tooltip when the close button is touched.
   */
  init: function init() {
    this.termQuerySelector = "a[href*=\"/".concat(this.postTypeSlug, "/\"]");
    this.terms = document.querySelectorAll(this.termQuerySelector);
    console.log(this);

    if (this.terms.length > 0) {
      this.bindEvents();
      var i = 0,
          l = this.terms.length;

      for (i; i < l; i++) {
        var term = this.terms[i];
        (0, _jquery.default)(term).hoverIntent({
          over: this.handleShowTooltip,
          out: this.handleHideTooltip,
          timeout: 300
        });
        /**
         * Add class to terms for easy styling.
         */

        term.classList.add('emg-term');
        /**
         * Prevent default when clicking glossary terms.
         */

        term.addEventListener('click', this.handleShowTooltip);
        /**
         * Accessibility considerations.
         */

        term.addEventListener('focus', this.handleShowTooltip);
        term.addEventListener('blur', this.handleHideTooltip);
        /**
         * Touch-device considerations.
         */

        document.addEventListener('touchstart', this.handleTouchStart);
        document.addEventListener('touchend', this.handleTouchEnd);
        /**
         * Handle closing the tooltip on touch screens.
         */

        (0, _jquery.default)(document).on('touchstart', '.emg-tooltip__close', this.handleCloseClick);
      }
    }
  },

  /**
   * Bind event handlers so they have access to this object using the 'this' keyword.
   * 
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
   * 
   * @since 1.0.0
   */
  bindEvents: function bindEvents() {
    this.handleShowTooltip = this.handleShowTooltip.bind(this);
    this.handleHideTooltip = this.handleHideTooltip.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  },

  /**
   * Event handler that determines if the glossary link has a tooltip, and if not, 
   * makes a request to the WP REST API to get the tooltip data, and adds the tooltip markup.
   * Then the tooltip is displayed to the user.
   * 
   * @since 1.0.0
   * @since 1.0.1 Showing the tooltip no matter what. Adding a "loading" class to the link in order to show an animation.
   * @since 1.0.3 Added check to see if close button is clicked, and if so, bailing early in order to hide the tooltip.
   * @since 1.0.4 Reference emGlossary.apiEndpoint instead of hard-coding the main site's endpoint.
   * 
   * @param {Event} e 
   */
  handleShowTooltip: function handleShowTooltip(e) {
    var _this = this;

    e.preventDefault();
    var termEl = (0, _jquery.default)(e.target).closest(this.termQuerySelector)[0];
    /**
     * Bail early if we don't have a term element.
     */

    if (!termEl || e.target.classList.contains('emg-tooltip__close')) {
      return;
    }
    /**
     * Show the tooltip.
     */


    this.showTooltip(termEl);
    /**
     * Otherwise, make a request to the WP REST API to get the term data,
     * and call this.loadTooltipContent on succes to add the tooltip markup to the link,
     * and then show the tooltip.
     */

    if (!termEl.classList.contains(this.tooltipLoadedClass)) {
      /**
       * Add the loading class to the glossary term link.
       */
      termEl.classList.add(this.tooltipLoadingClass);
      var pathnamePieces = termEl.pathname.split('/');
      var slug = encodeURIComponent(pathnamePieces[pathnamePieces.indexOf(this.postTypeSlug) + 1]);
      /**
       * Make sure there isn't another XMLHttpRequest in progress before continuing.
       */

      var _loop = function _loop() {
        /**
         * Don't allow new requests to be made while this request is processing.
         */
        _this.requestInProgress = true;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', "".concat(_this.apiEndpoint, "?slug=").concat(slug));

        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 400) {
            _this.loadTooltipContent(termEl, xhr.responseText);
          } else {
            console.log(Error(xhr.statusText));
          }
          /**
           * Allow new requests to be made. now that this request in finsihed.
           */


          _this.requestInProgress = false;
        };

        xhr.onerror = function () {
          console.log(Error('Network Error'));
        };

        xhr.send();
      };

      while (!this.requestInProgress) {
        _loop();
      }
    }
  },

  /**
   * Hide the tooltip.
   * 
   * @since 1.0.0
   * @since 1.0.1 Using jQuery closest() instead of native closest() for IE11 support.
   * @since 1.0.2 Added logic to position the tooltip properly on screens smaller than 480px wide.
   * 
   * @param {Event} e 
   */
  handleHideTooltip: function handleHideTooltip(e) {
    var termEl = (0, _jquery.default)(e.target).closest(this.termQuerySelector)[0];

    if (termEl) {
      this.hideTooltip(termEl);
    }
  },

  /**
   * Store the page's Y position to check if the user has touchmoved.
   * 
   * @since 1.0.1
   * 
   * @param {Event} e 
   */
  handleTouchStart: function handleTouchStart(e) {
    this.pageY = e.changedTouches[0].pageY;
  },

  /**
   * Hide the currently open tooltip if it's not our event's target, 
   * it currently has the showTooltipClass applied, and the user hasn't
   * performed a touchmove event.
   * 
   * @since 1.0.1
   * 
   * @param {Event} e 
   */
  handleTouchEnd: function handleTouchEnd(e) {
    /**
     * Only proceed if there is an open tooltip, and it's not our event's target, 
     * and it currently has the showTooltipClass applied.
     */
    if (e.changedTouches[0].pageY === this.pageY && this.openTooltip && this.openTooltip !== e.target && this.openTooltip.classList.contains(this.showTooltipClass)) {
      this.hideTooltip(this.openTooltip);
    }
  },

  /**
   * Add the glossary term tooltip, containing title and definition, as a child of the passed element.
   * 
   * @since 1.0.0
   * @since 1.0.1 Changed function from addTooltip to loadTooltipContent. Checking for title and content 
   * before adding tooltip.
   * @since 1.0.3 Running this.showTooltip(el) at the end of loadTooltipContent() in order to recalculate 
   * the tooltip's top position with its full height.
   * 
   * @param {Node} el Element to add the tooltip to.
   * @param {String} data JSON string from WP REST API request.
   */
  loadTooltipContent: function loadTooltipContent(el, data) {
    data = JSON.parse(data)[0];

    if (data.title.rendered && data.content.rendered) {
      var tooltipInner = el.querySelector(".".concat(this.tooltipClass, "__inner"));
      /**
       * Add the tooltip content to the tooltip.
       */

      tooltipInner.innerHTML += "<div class=\"".concat(this.tooltipClass, "__content\">\n\t\t\t\t<div class=\"").concat(this.tooltipClass, "__title\">").concat(data.title.rendered, "</div>\n\t\t\t\t").concat(data.content.rendered, "\n\t\t\t</div>");
      /**
       * Remove the loading class and add the loaded class.
       */

      el.classList.remove(this.tooltipLoadingClass);
      el.classList.add(this.tooltipLoadedClass);
      this.showTooltip(el);
    }
  },

  /**
   * Show the tooltip.
   * 
   * @since 1.0.0
   * @since 1.0.1 Check if tooltip markup has been added to the link before querying for it.
   * @since 1.0.1 Setting left to 'auto', instead of '', if the tooltip is offscreen right.
   * @since 1.0.3 Added conditional logic to detect if the tooltip is going to appear off the top of the screen,
   * or over a user-defined topOffsetEl, which can be set on window.emGlossaryOptions.topOffsetEl.
   * 
   * @param {Node} el Element containing the tooltip to show.
   */
  showTooltip: function showTooltip(el) {
    /**
     * Add tooltip markup if it hasn't already been added.
     */
    if (!el.classList.contains(this.hasTooltipClass)) {
      el.innerHTML += "<div class=\"".concat(this.tooltipClass, "\"><div class=\"").concat(this.tooltipClass, "__inner\"></div><div class=\"").concat(this.tooltipClass, "__close\"></div></div>");
      el.classList.add(this.hasTooltipClass);
    }

    var tooltip = el.querySelector(".".concat(this.tooltipClass));
    /**
     * Reset tooltip styles to defaults.
     */

    tooltip.style.cssText = '';
    /**
     * Make sure the tooltip isn't bleeding off the edges of the screen,
     * and if it is, bring it back into view.
     */

    var tooltipRect = tooltip.getBoundingClientRect();

    if (window.innerWidth <= 480) {
      tooltip.style.marginLeft = "".concat(-tooltipRect.left + 20, "px");
    } else {
      if (tooltipRect.left < 20) {
        tooltip.style.left = 0;
        tooltip.style.transform = 'none';
      } else if (tooltipRect.left + tooltipRect.width > window.innerWidth) {
        tooltip.style.left = 'auto';
        tooltip.style.right = 0;
        tooltip.style.transform = 'none';
      }
    }

    if (!el.classList.contains(this.tooltipBottomClass)) {
      var topOffsetEl = window.emGlossaryOptions ? window.emGlossaryOptions.topOffsetEl : false;
      var topOffsetHeight = (topOffsetEl ? topOffsetEl.clientHeight : 0) + 15;

      if (tooltipRect.top >= topOffsetHeight) {
        el.classList.remove(this.tooltipBottomClass);
      } else {
        el.classList.add(this.tooltipBottomClass);
      }
    }

    el.classList.add(this.showTooltipClass);
    this.openTooltip = el;
  },

  /**
   * Hide the tooltip.
   * 
   * @since 1.0.0
   * 
   * @param {Node} el Element containing the tooltip to hide.
   */
  hideTooltip: function hideTooltip(el) {
    var _this2 = this;

    if (!el) {
      return;
    }

    el.classList.remove(this.showTooltipClass);
    setTimeout(function () {
      el.classList.remove(_this2.tooltipBottomClass);
    }, 300);
  },

  /**
   * Close the tooltip when the close button is touched.
   * 
   * @since 1.0.3
   * 
   * @param {Event} e 
   */
  handleCloseClick: function handleCloseClick(e) {
    var $closeButton = (0, _jquery.default)(this);
    var $glossaryLink = $closeButton.closest(this.termQuerySelector);
    this.hideTooltip($glossaryLink[0]);
  }
});

glossary.init();
/**
 * Re-run on gravity forms confirmations.
 */

var confirmationCount = 1;
(0, _jquery.default)(document).on('gform_confirmation_loaded', function (event, formId) {
  /**
   * Seems to run twice, so added a check to only run once.
   */
  if (confirmationCount === 1) {
    glossary.init();
    confirmationCount++;
  }
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}]},{},[1])

